import { ModelConstants } from '../../model/model-constants';
import { format } from '../..//shared/utils/string.util';
import { AdapterContext } from '../adapters/adapter-context';
import { Metamodel } from '../base/model';
import { Named } from '../base/named';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { GlobalVariables } from '../../constants/globals';

export interface ISummaryDependency {
    id: string;
    type: string;
    subType?: string;
}

export interface ISummary {
    id: string;
    description?: string;
    dependencies?: ISummaryDependency[];
}

export class ModelUtilties {
    public static async toResources(context: AdapterContext, named: Named, isPublish: boolean = false, forArmTemplate: boolean = false): Promise<{ [key: string]: {} }> {
        const model = Metamodel.modelOf(named);

        if (!model.concept) {
            throw new Error(' Only concept models can be persisted ');
        }

        let resource;
        if (context.isAsyncAdapter(model)) {
            const asyncAdapter = context.asyncAdapterFor(model);
            if (asyncAdapter) {
                resource = await asyncAdapter.toResource(named, isPublish, forArmTemplate);
            }
        } else {
            const adapter = context.adapterFor(model);
            if (adapter) {
                resource = adapter.toResource(named, isPublish, forArmTemplate);
            }
        }

        if (!resource) {
            let modelName = model.name;
            if (modelName === ModelConstants.linkedService) {
                modelName = GlobalVariables.isTrident ? shellStringResources.ConnectionLabel : shellStringResources.ModelName_LinkedService;
            }
            throw new Error(format(shellStringResources.DataFlowErrorAdapterNotFound, modelName));
        }
        return {
            [model.concept.name]: resource
        };
    }

    public static async toResource(context: AdapterContext, named: Named, isPublish: boolean = false, forArmTemplate: boolean = false): Promise<{}> {
        const model = Metamodel.modelOf(named);

        let resource;
        if (context.isAsyncAdapter(model)) {
            const asyncAdapter = context.asyncAdapterFor(model);
            if (asyncAdapter) {
                resource = await asyncAdapter.toResource(named, isPublish, forArmTemplate);
            }
        } else {
            const adapter = context.adapterFor(model);
            if (adapter) {
                resource = adapter.toResource(named, isPublish, forArmTemplate);
            }
        }

        return resource;
    }
}
